import { useMutation } from "@apollo/client/react";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import { DeletePlannedBreak } from "./plannedBreak.gql";

export default function useDeletePlannedBreak() {
  const { setNotification } = useNotificationState();
  const [deletePlannedBreak] = useMutation(DeletePlannedBreak, {
    onCompleted: ({ deletePlannedBreak: { name } }) => {
      setNotification({
        message: `${name} has been deleted.`,
        title: "",
        type: "success",
      });
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to delete planned break",
          type: "danger",
        });
      });
    },
  });

  return (options) => deletePlannedBreak(options);
}
